<template>
  <div class="gridlayout">
    <div v-for="(rowNumber, rowIndex) in numberOfRows">
      <div class="gridlayout-row">
        <div    class="gridlayout-cell"
                :style="cellStyles"
                v-for="slide in row(rowIndex)">
            <cropzoomImg
                ref="imgs"
                :key="slide.title"
                :src="slide.imageUrl"
                :title="slide.title"
                :alt="slide.alt"
                :aspect-ratio="aspectRatio"
                :data="slide"
                :click-callback="handleClick"/>
        </div>
      </div>
    </div>
    <div class="gridlayout-hasMoreUrl" v-if="options.hasMoreUrl">
        <a class="btn btn-primary btn-primary-ghost" v-bind:href="options.moreUrl">View More</a>
    </div>
  </div>
</template>

<script>
import cropzoomImg from "./cropzoomImg.vue";
const DEBUG = false;
export default {
    name: 'gridlayout',
    props: {
        options: Object,
        aspectRatio: Number,
        clickCallback: {
            type: Function,
            default: null,
        }
    },
    components: {
        cropzoomImg,
    },
    data: function () {
        return {
            numColumns: this.calcNumColumns(),
            fixedNumColumns: false,
        };
    },
    computed: {
        cellStyles: function () {
            const widthPercent = 100/this.numColumns;
            return {
                width: `${widthPercent}%`,
            }
        },
        numSlides: function () {
            return this.options.slides.length;
        },
        numberOfRows:  function () {
            const slides = this.$props.options.slides;
            const num = slides.length;
            let numRows = Math.ceil(num/this.numColumns);
            if (DEBUG) console.log("gl61: numrows", {
                num, numRows, numColumns: this.numColumns
            })
            return numRows;
        },
    },
    methods: {
        calcNumColumns: function () {
            const mediaType = this.getMediaType();
            let numCols = 4;
            switch(mediaType) {
                case "xs":
                    numCols = 1;
                    break;
                case "md":
                    numCols = 2;
                    break;
                case "lg":
                    numCols = 3;
                    break;
                default:
                case "desktop":
                    numCols = 4;
                    break;
            }
            // special cases
            const numSlides = this.numSlides;
            if (numSlides < numCols) {
                numCols = numSlides;
            }
            // result
            this.numColumns = numCols;
            return numCols; // not currently used afaik
        },
        getMediaType: function () {
            const isXS = window.matchMedia("(max-width: 767px)").matches;
            const isMD = window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches;
            const isLG = window.matchMedia("(min-width: 992px) and (max-width: 1199px)").matches;
            const isGiant = window.matchMedia("(min-width: 1200px)").matches;
            if (isXS) { return "xs";}
            else if (isMD) { return "md";}
            else if (isLG) { return "lg";}
            else /* if (isGiant) */ { return "desktop"};
        },
        handleClick: function (event, data) {
            if (DEBUG) console.log("gl106: gridlayout handleClick", event, data);
            if (this.$props.clickCallback) {
                this.$props.clickCallback(event, data);
            }
        },
        handleCurrentSize: function () {
            if (DEBUG) console.log("gl112: handleCurrentSize")
            this.calcNumColumns();
            for (let img of this.$refs.imgs) {
                img.handleCurrentSize();
            }
            this.$nextTick(() => this.$forceUpdate());
        },
        row: function (rowIndex) {
            const slideStart = rowIndex*this.numColumns;
            const slideEnd   = slideStart + this.numColumns;

            return this.$props.options.slides.slice(slideStart, slideEnd);
        },
    },
    // li
    created: function () {
        window.addEventListener('resize', () => this.handleCurrentSize());
    },
    mounted: function () {
        //this.$nextTick( () => this.handleCurrentSize() );
        if (DEBUG) console.log("gl132: props options", this.$props.options );
        this.handleCurrentSize();
        this.$nextTick( () => this.$forceUpdate());
  }
};
</script>

<style lang="scss">
.gridlayout {
    background: none;
    width: 100%;
    padding: 15px 0 15px;
}
.gridlayout-row {
    line-height: 0; // gets rid of little space at bottom
    margin: 0 -15px;
    // border: dashed black 1px;
}
.gridlayout-cell {
    display: inline-block;
    overflow: hidden;
    padding: 15px;

    .cropzoomimg-container {
        max-width: 1200px
    }
}
.gridlayout-hasMoreUrl {
    margin: 2rem 0 2rem;
    text-align: center;
    width: 100%;
}
</style>
